import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

class Testimonials {
  constructor() {
    this.sliders = document.querySelectorAll('.js-testimonials-slider');

    if (!this.sliders.length) {
      return;
    }

    this.init();
  }

  init() {
    this.sliders.forEach(el => {
      const autoplay = el.dataset.autoplay === 'true';

      /* eslint-disable no-new */
      new Swiper(el, {
        modules: [Navigation, Pagination, Autoplay],
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
        },
        autoplay: autoplay
          ? { delay: 5000, disableOnInteraction: false }
          : false,
      });
    });
  }
}

export default new Testimonials();



// WEBPACK FOOTER //
// ./src/scripts/modules/testimonials.js